import React, { useState, useEffect, useRef } from "react"
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import moment from 'moment';
import 'moment/locale/fr'

import APIS from "../utils/APIS"
import { getCurrentUser } from "../utils/auth"
import bellIcon from "../images/bellIcon.svg"

moment.locale("fr");

// S8 : cloche de notifications. Les évènements sont calculés côté serveur à
// partir des résultats des candidats (scan terminé, compatible ou non).
// Les notifications lues sont mémorisées localement (pas de table dédiée).

const CLE_LUES = "RisUpTheScanNotifsLues"

const lireLues = () => {
  try { return JSON.parse(window.localStorage.getItem(CLE_LUES) || "[]") } catch (e) { return [] }
}

const cle = (n) => `${n.scanID}-${n.userEmail}-${n.date}`

const NotificationsBell = () => {
  const navigate = useNavigate();
  const [notifs, setNotifs] = useState([])
  const [lues, setLues] = useState(lireLues())
  const [ouvert, setOuvert] = useState(false)
  const zone = useRef(null)

  useEffect(() => {
    APIS.getNotifications().then((r) => {
      if (r?.message === "getNotifications") {
        /* PD-10 (25/09/2026) : decision d'Hicham, un candidat ne voit AUCUNE
           statistique de ses resultats. Hors recruteur, on ne garde que les
           invitations : jamais une ligne « a termine son scan · Compatible /
           Incompatible », meme si le serveur en renvoyait. Le filtre est pose
           ici, a la reception, pour que la pastille (nombre de non lues) et
           la liste comptent les memes notifications. Meme definition du
           recruteur que DashboardNavbar (type "theScanRecruiter"). */
        const toutes = r.notifications || []
        const estRecruteur = getCurrentUser()?.type === "theScanRecruiter"
        setNotifs(estRecruteur ? toutes : toutes.filter((n) => n?.type === "invitation"))
      }
    })
  }, [])

  useEffect(() => {
    const dehors = (e) => { if (zone.current && !zone.current.contains(e.target)) setOuvert(false) }
    document.addEventListener("mousedown", dehors)
    return () => document.removeEventListener("mousedown", dehors)
  }, [])

  const nonLues = notifs.filter((n) => !lues.includes(cle(n)))

  const ouvrir = () => {
    const suivant = !ouvert
    setOuvert(suivant)
    if (suivant && nonLues.length > 0) {
      const toutes = notifs.map(cle)
      window.localStorage.setItem(CLE_LUES, JSON.stringify(toutes))
      setLues(toutes)
    }
  }

  return (
    <Box ref={zone} sx={{position:"relative", display:"flex", alignItems:"center"}}>
      <Box
        onClick={ouvrir}
        sx={{
          display:"flex", alignItems:"center", justifyContent:"center",
          width:"40px", height:"40px", cursor:"pointer", position:"relative",
          color:"text.black",
          "&:hover" : { opacity:0.7 },
        }}
      >
        <img src={bellIcon} style={{width:"20px", height:"22px"}} alt="Notifications"/>
        {nonLues.length > 0 &&
          <Box sx={{
            position:"absolute", top:"6px", right:"6px",
            minWidth:"16px", height:"16px", padding:"0 4px",
            background:"#C62828", color:"white",
            fontSize:"10px", lineHeight:"16px", textAlign:"center",
            borderRadius:"8px",
            pointerEvents:"none", // la pastille interceptait le clic sur la cloche
          }}>
            {nonLues.length > 9 ? "9+" : nonLues.length}
          </Box>
        }
      </Box>

      {ouvert &&
        <Box sx={{
          position:"absolute", top:"58px", right:0,
          width:"360px", maxWidth:"calc(100vw - 30px)",
          background:"white", border:"1px solid black",
          boxShadow:"0px 1px 20px rgba(0,0,0,0.1)",
          zIndex:1300, maxHeight:"420px", overflowY:"auto",
        }}>
          <Box sx={{padding:"14px 16px", borderBottom:"1px solid #EFEFEF", fontSize:"16px", color:"text.black"}}>
            Notifications
          </Box>

          {notifs.length === 0 &&
            <Box sx={{padding:"20px 16px", fontSize:"14px", color:"#565656"}}>
              Aucune notification pour le moment.
            </Box>
          }

          {notifs.map((n, i) => (
            <Box
              key={i}
              onClick={() => {
                setOuvert(false)
                navigate(n.type === "invitation" ? '/app/scans' : '/app/scan/' + n.scanID)
              }}
              sx={{
                padding:"12px 16px",
                borderBottom:"1px solid #EFEFEF",
                cursor:"pointer",
                display:"flex", flexDirection:"column", gap:"3px",
                "&:hover" : { backgroundColor:"#F7F7F7" },
              }}
            >
              <Box sx={{fontSize:"14px", color:"text.black"}}>
                {n.type === "invitation"
                  // Point 3 : l'entreprise, jamais le nom du recruteur
                  ? `${n.company || "Une entreprise"} vous a invité`
                  : `${n.userName || n.userEmail} a terminé son scan`}
              </Box>
              <Box sx={{fontSize:"13px", color:"#6B6B6B"}}>
                {n.type === "invitation"
                  ? n.scanName
                  : `${n.scanName} · ${n.compatible ? "Compatible" : "Incompatible"}`}
              </Box>
              <Box sx={{fontSize:"12px", color:"#8A8A8A"}}>
                {n.date ? moment(n.date).fromNow() : ""}
              </Box>
            </Box>
          ))}
        </Box>
      }
    </Box>
  )
}

export default NotificationsBell
